import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import WarningIcon from "@mui/icons-material/Warning";
import { hideWarning } from "../../redux/common/actions";
import CurveButton from "./CurveButton";

const useStyles = makeStyles()((theme) => {
	return {
		dialogTitle: {
			backgroundColor: "#ED8738",
			color: "#FFFFFF",
			display: "flex",
			justifyContent: "center",
		},
		dialogAction: {
			display: "flex",
			justifyContent: "center",
		},
	};
});

// Same dialog pattern as ErrorDialog/SuccessDialog, but non-blocking by nature: whatever
// triggered this warning (e.g. a Task List Number reused elsewhere) has already been
// saved - "Continue" just acknowledges the warning, it doesn't undo anything.
const WarningDialog = ({ warning, removeWarning }) => {
	const { t } = useTranslation();
	const { classes, cx } = useStyles();
	const handleClose = () => removeWarning();

	return (
		<Dialog
			open={warning.status}
			onClose={handleClose}
			fullWidth
			style={{ position: "absolute" }}
		>
			<DialogTitle className={classes.dialogTitle}>
				<WarningIcon style={{ fontSize: "9rem" }} />
			</DialogTitle>
			<DialogContent style={{ textAlign: "center" }}>
				<h1>{warning.message}</h1>
				{warning.items?.length ? (
					<ul style={{ textAlign: "left", display: "inline-block" }}>
						{warning.items.map((item, index) => (
							<li key={index}>{item}</li>
						))}
					</ul>
				) : null}
			</DialogContent>
			<DialogActions className={classes.dialogAction}>
				<CurveButton
					style={{ backgroundColor: "#ED8738" }}
					onClick={handleClose}
				>
					{t("action.continue")}
				</CurveButton>
			</DialogActions>
		</Dialog>
	);
};

const mapStateToProps = ({ commonData: { warning } }) => ({ warning });
const mapDispatchToProps = (dispatch) => ({
	removeWarning: () => dispatch(hideWarning()),
});

export default connect(mapStateToProps, mapDispatchToProps)(WarningDialog);
